import { mergeMap, catchError, map, filter, concatAll } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ofType } from 'redux-observable';
import i18next from 'i18next';
import { getCustomer, listCustomers } from 'gql/Customer';
import RootEpic from 'store/RootEpic';
import CustomerSlice from 'components/pages/console/store/CustomerSlice';
import { showNotificationFromError } from 'components/app/store/UserSlice';
import { PermissionAction, PermissionResource, hasPermission } from 'gql/Permission';

export const fetchCustomerEpic: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(() =>
      hasPermission(state$.value.user.user?.permissions, PermissionAction.READ, PermissionResource.CUSTOMER)
    ),
    ofType(CustomerSlice.actions.fetchCustomer),
    mergeMap(({ payload }) => {
      return from(getCustomer(payload)).pipe(
        map((response) => {
          return CustomerSlice.actions.fetchCustomerSucceeded(response);
        }),
        catchError((error) => {
          return of(CustomerSlice.actions.fetchCustomerFailed(error));
        })
      );
    })
  );

export const fetchCustomerFailedEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(CustomerSlice.actions.fetchCustomerFailed),
    map(({ payload }) => showNotificationFromError({ msg: i18next.t('FAILED_GET_CUSTOMER'), err: payload }))
  );

export const fetchCustomersEpic: RootEpic = (action$, state$) => {
  return action$.pipe(
    filter(() => {
      return hasPermission(state$.value.user.user?.permissions, PermissionAction.READ, PermissionResource.CUSTOMER);
    }),
    filter((action) => {
      return CustomerSlice.actions.fetchCustomers.match(action);
    }),
    mergeMap(({ payload }) => {
      return from(listCustomers(payload)).pipe(
        map((response) => {
          return response.nextToken
            ? [
                CustomerSlice.actions.fetchCustomersSucceeded(response.items),
                CustomerSlice.actions.fetchCustomers({
                  nextToken: response.nextToken,
                }),
              ]
            : [CustomerSlice.actions.fetchCustomersSucceeded(response.items)];
        }),
        concatAll(),
        catchError((error) => {
          return of(CustomerSlice.actions.fetchCustomersFailed(error));
        })
      );
    })
  );
};

export const fetchCustomersFailedEpic: RootEpic = (action$) =>
  action$.pipe(
    ofType(CustomerSlice.actions.fetchCustomersFailed),
    map(({ payload }) => showNotificationFromError({ msg: i18next.t('FAILED_GET_CUSTOMERS'), err: payload }))
  );

const CustomerEpics: RootEpic[] = [
  fetchCustomerEpic,
  fetchCustomerFailedEpic,
  fetchCustomersEpic,
  fetchCustomersFailedEpic,
];

export default CustomerEpics;
